module.exports = "pegasus_template/assets/circleline-youtube.gif";